import {
  rxEmailAddress,
  rxMuellerEmailAddress,
  rxSemiColonSeparatedEmailAddresses,
  rxPhoneNumber,
  rxZipcode
} from "tools/regularExpressions";

const validator = {
  required(data, field, value) {
    if (value == null || `${value}`.trim() == "") return "This field is required.";
  },
  emailAddress(data, field, value) {
    if (value) {
      if (!rxEmailAddress.test(value)) return "Valid email is required.";
    }
  },
  muellerEmailAddress(data, field, value) {
    if (value) {
      if (!rxMuellerEmailAddress.test(value)) return "Valid muellerreports.com email is required.";
    }
  },
  semiColonSeparatedEmailAddresses(data, field, value) {
    if (!rxSemiColonSeparatedEmailAddresses.test(value)) return "Emails must be valid and separated by semicolons (;).";
  },
  semiColonSeparatedEmailAddressesRequired(data, field, value) {
    if (value == null || value == "") return "Email is required. Separate multiple emails with a semicolon(;)";
    if (!rxSemiColonSeparatedEmailAddresses.test(value)) return "Emails must be valid and separated by semicolons (;).";
  },
  phoneNumber(Data, field, value) {
    if (value) {
      if (!rxPhoneNumber.test(value.toString())) return "Valid phone number is required.";
    }
  },
  zipcode(Data, field, value) {
    if (value) {
      if (!rxZipcode.test(value.toString())) return "Valid 5 digit zip code is required.";
    }
  },
  integer(Data, field, value) {
    if (value.length > 0 && (isNaN(value) || value % 1 != 0)) return "Please enter a whole number";
  },

  year(Data, field, value) {
    if (value.length > 0 && (isNaN(value) || (value % 1 != 0) || (1000 > value || value > 3000))) return "Please enter a valid year";
  },

  maxLength(count) {
    return function max_Length(Data, field, value) {
      if (value.length > count) return "Please enter a length less than or equal to " + count;
    };
  },

  notRequired(Data, field, value) {
    if (!value) return false;
  },

  money(Data, field, value) {
    if ((value && isNaN(value)) || (value && value > 900000000)) return "Please enter a valid number";
  },

  combineValidators(...validator) {
    return function combo(Data, field, value) {
      let validatorList = validator;
      let result;

      for (const rule of validatorList) {
        if (typeof rule !== "function") continue;
        result = rule(Data, field, value);
        if (result != null) break;
      }

      return result;
    };
  }
};

export default validator;
